module.exports = __webpack_public_path__ + "img/dashboard_personal.1cd736c1.svg";